module.exports = __webpack_public_path__ + "img/aboutus.9dd6e33b.svg";